import $ from 'jquery';
import { View } from 'backbone';
import formatTemplate from 'properties/advanced/viewing.ejs';
import listService       from 'ListService';
import StageAndRoleSettingsModal from 'common-views/StageAndRoleSettingsModal';
import StartPageSettingModal from 'common-views/StartPageSettingModal';
import constants from 'Constants';
import util from 'util/Util.js';

class ViewingView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        const states = this.model.get('States');
        const startPages = this.model.get('StartPages');

        if (states){
            this.model.set('viewingState', Array.isArray(states.State) ? states.State[0]._value : states.State._value, constants.MODEL_SILENT);
        }

        if (startPages){
            this.model.set('startPage',startPages.startPage.length ? listService.cleanId(startPages.startPage[0].value) :'', constants.MODEL_SILENT);
        }

        // PF-1366:
        this.options = constants.FLASH_STATE_OPTIONS;
        if (!this.model.has('state')) {
            if(states){
                let state = new Map();
                states.State = util.enforceArrayType(states.State);
                states.State.forEach((elem)=>{
                    state.set(elem._id,{id:elem._id,value:elem._value});
                });
                this.model.set('state', state, constants.MODEL_SILENT);
             
            }
            else {
                this.model.set('state', new Map(), constants.MODEL_SILENT);
            }
        }

        if (!this.model.has('startPages')) {

            if(startPages){
                let startP = new Map();
                startPages.startPage = util.enforceArrayType(startPages.startPage);
                startPages.startPage.forEach((elem)=>{
                    startP.set(elem.id,{id:elem.id,value:elem.value});
                });
                this.model.set('startPages', startP, constants.MODEL_SILENT);
            }
            else {
                this.model.set('startPages', new Map(), constants.MODEL_SILENT);
            }
        }


        this.events = {
            'change #viewingState, #startPage': 'updateSelectAttributes',
            'click #browseState': 'displaySelectStateModal',
            'click #browseStartPage': 'displaySelectStartPageModal'
        };

        this.listenTo(this.model, constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED, this.updateRoleAndStage);
        this.listenTo(this.model, constants.EV_START_PAGE_SETTINGS_UPDATED, this.updateStartPage);
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    // Event trigger handler
    updateRoleAndStage() {
        $('#viewingState').attr(this.model.get('viewingState'));
        this.render();
    }

    // Event trigger handler
    updateStartPage() {
        $('#startPage').attr(this.model.get('startPage'));
        this.render();
    }

    // Inserted for PF-1366:
    displaySelectStateModal(ev){
        ev.preventDefault();
        new StageAndRoleSettingsModal({
            settings: this.model.get('state'),
            model: this.model,
            options: this.options,
            propertyName: "value",
            defaultValue: "normal",
            title: "Edit State"
        }).render();
    }

    // Inserted for PF-1366:
    displaySelectStartPageModal(ev) {
        ev.preventDefault();
        new StartPageSettingModal( {
            settings: this.model.get('startPages'),
            model: this.model,
            options: this.options,
            propertyName: "value",
            defaultValue: "default",
            title: "Edit Start Page",
            currentPages: [...listService.pageList.values()]
        }).render();
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal = ev.currentTarget.value;

        // must account for PageId that may have been cleaned (from PF original ID)
        propVal = listService.getCleanedId(propVal);

        this.model.set( propName, propVal );

        if (propName === 'viewingState') {
            const
                propName = 'States',
                states = this.model.get(propName);
            states.State._value = propVal;
            this.model.set(propName, states);
        } else {
            const
                propName = 'startPages',
                startPages = this.model.get(propName);

            if(startPages && startPages.startPage){

                //PF-5950 All the pages with default should set to the defined page in Start Page
                _.each(startPages.startPage, (stage) => {
                   
                    if(stage.value === "default"){
                        stage.value = propVal;
                    }

                });
               
            }
            this.model.set(propName, startPages);
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.model.get('viewingState')) {
            $('#viewingState').find("option[value='"+this.model.get('viewingState')+"']").attr('selected', true);
        }

        // Retrieving current pages from the listService.
        const currentPages=[...listService.pageList.values()];


        $('#startPage').append($('<optgroup label="──────────">'));
        for(let page of currentPages){
            $('#startPage').append($('<option>',{
                value: page.model.get('id'),
                text: page.model.get('name')
            }));
        }
        $('#startPage').append($('</optgroup>'));

        if(this.model.get('startPage')) {
            // must account for PageId that may have been cleaned (from PF original ID)
            let selectedPage = this.model.get('startPage');
            if ( selectedPage!== 'default' && selectedPage!=='last' &&
                !listService.isValidId(selectedPage) ) {
                selectedPage = listService.cleanId(selectedPage);
            }

            $('#startPage').find("option[value='"+ selectedPage +"']").attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }
}

export default ViewingView;
